import { useMutation } from "@tanstack/react-query";
import { OrdersListElementType } from "../interface";
import { AxiosError } from "axios";
import { useModal } from "../../../../../hooks";
import { postOrderShipmentExportShipmentInvoiceExcelApi } from "../../../../../api/order/OrdersApi";

export const usePostOrderShipmentExportShipmentInvoiceExcel = () => {
  const { handleModal } = useModal();

  const { mutate } = useMutation({
    mutationFn: (data: OrdersListElementType[]) =>
      postOrderShipmentExportShipmentInvoiceExcelApi(data),
    onSuccess: (blob: Blob) => {
      // 파일 다운로드 트리거
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "shipment_invoice.xlsx"; // 다운로드될 파일 이름
      a.click();
      window.URL.revokeObjectURL(url);
    },
    onError: (error: AxiosError<{ msg?: string }>) => {
      handleModal({
        isOpen: true,
        title: "송장 내보내기 실패",
        contents: error.response?.data?.msg ?? "엑셀 다운로드에 실패했습니다.",
        type: "alert",
      });
    },
  });

  return { mutate };
};
